import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISessionInfo } from '../types/ISessionInfo';

export interface ISwitchSiteParams {
  urlName: string;
}

export interface ISwitchSiteResult extends ISessionInfo {
}

export class SwitchSiteRequest extends Request<ISwitchSiteParams, ISwitchSiteResult> {
  constructor(params: ISwitchSiteParams) {
    super('switchSite', params);
  }
}
